/* eslint-disable */
import { produce } from "immer";
import {
  CONTRIBUTION_VIEW_FETCH_START,
  CONTRIBUTION_VIEW_FETCH_SUCCESS,
  CONTRIBUTION_VIEW_FETCH_FAILURE,
} from "../actions/types";

const contributionView = (
  state = {
    contributionViewFetching: false,
    contributionViewData: [],
    contributionViewError: null,
  },
  action,
) => {
  switch (action.type) {
    case CONTRIBUTION_VIEW_FETCH_START:
      return produce(state, (draft) => {
        draft.contributionViewFetching = true;
      });
    case CONTRIBUTION_VIEW_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.contributionViewFetching = true;
        draft.contributionViewData = action.data;
        draft.contributionViewFetching = false;
      });
    case CONTRIBUTION_VIEW_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.contributionViewFetching = false;
        draft.contributionViewError = action.error;
      });
    default:
      return state;
  }
};

export default contributionView;
